import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircleIcon, TrendingDownIcon, ClockIcon, CpuIcon } from 'lucide-react';
import { SlideLayout, itemVariants } from '../ui/SlideLayout';
export function ProblemSlide() {
  return <SlideLayout data-id="element-353">
      <motion.div variants={itemVariants} className="mb-16" data-id="element-354">
        <h2 className="text-4xl md:text-5xl font-bold text-brand-text mb-6" data-id="element-355">
          GPUs Became the Default by Convenience,{' '}
          <span className="text-brand-text-muted" data-id="element-356">Not by Design</span>
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-357">
        <motion.div variants={itemVariants} className="lg:col-span-7 space-y-8" data-id="element-358">
          <div className="flex gap-4 items-start" data-id="element-359">
            <div className="mt-1 p-2 bg-brand-bg-card rounded-lg border border-brand-border text-brand-teal" data-id="element-360">
              <CpuIcon className="w-6 h-6" data-id="element-361" />
            </div>
            <div data-id="element-362">
              <h3 className="text-xl font-semibold text-brand-text mb-2" data-id="element-363">
                Inherited from Training
              </h3>
              <p className="text-brand-text-dim leading-relaxed" data-id="element-364">
                There is a GPU in every computer, making it the natural place
                for large matrix multiplications. But inference workloads are
                fundamentally different from training.
              </p>
            </div>
          </div>

          <div className="flex gap-4 items-start" data-id="element-365">
            <div className="mt-1 p-2 bg-brand-bg-card rounded-lg border border-brand-border text-brand-teal" data-id="element-366">
              <TrendingDownIcon className="w-6 h-6" data-id="element-367" />
            </div>
            <div data-id="element-368">
              <h3 className="text-xl font-semibold text-brand-text mb-2" data-id="element-369">
                Poor Utilization at Scale
              </h3>
              <p className="text-brand-text-dim leading-relaxed" data-id="element-370">
                Cloud GPU costs dominate AI budgets. Utilization rates are often
                20–30% for real-time workloads running at low batch sizes.
              </p>
            </div>
          </div>

          <div className="flex gap-4 items-start" data-id="element-371">
            <div className="mt-1 p-2 bg-brand-bg-card rounded-lg border border-brand-border text-brand-teal" data-id="element-372">
              <ClockIcon className="w-6 h-6" data-id="element-373" />
            </div>
            <div data-id="element-374">
              <h3 className="text-xl font-semibold text-brand-text mb-2" data-id="element-375">
                Unpredictable Latency
              </h3>
              <p className="text-brand-text-dim leading-relaxed" data-id="element-376">
                Non-deterministic scheduling causes latency spikes (jitter) that
                break SLAs for real-time applications like voice agents and
                trading systems.
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div variants={itemVariants} className="lg:col-span-5" data-id="element-377">
          <div className="bg-brand-bg-card border border-brand-border rounded-2xl p-8 relative overflow-hidden" data-id="element-378">
            <div className="absolute top-0 right-0 w-32 h-32 bg-brand-teal/10 blur-3xl rounded-full" data-id="element-379" />

            <div className="mb-6" data-id="element-380">
              <AlertCircleIcon className="w-8 h-8 text-brand-teal mb-4" data-id="element-381" />
              <h3 className="text-2xl font-bold text-brand-text mb-2" data-id="element-382">
                The Industry is Moving
              </h3>
              <p className="text-brand-text-dim" data-id="element-383">
                ~30% of inference today already runs on non-GPU platforms
                (ASICs, custom silicon).
              </p>
            </div>

            <div className="mt-8 pt-8 border-t border-brand-border" data-id="element-384">
              <div className="text-5xl font-bold text-brand-teal mb-4" data-id="element-385">50%</div>
              <p className="text-lg text-brand-text font-medium mb-1" data-id="element-386">
                of AI inference will run on non-GPU platforms by 2027
              </p>
              <p className="text-sm text-brand-text-muted" data-id="element-387">— Goldman Sachs</p>
            </div>
          </div>
        </motion.div>
      </div>
    </SlideLayout>;
}